module.exports = __webpack_public_path__ + "static/img/kele.79b2240.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/kele.png
// module id = oK/m
// module chunks = 0